<template>
  <div>
    <div class="bg-dark m-b-30">
      <div class="container">
        <div class="row p-b-60 p-t-60">

          <div class="col-md-6 text-white p-b-30">
            <div class="media">
              <div class="avatar avatar mr-3">
                <div class="avatar-title bg-success rounded-circle mdi mdi-security"></div>
              </div>
              <div class="media-body">
                <h3 class="p-t-10">{{ pageTitle }} </h3>
                <p class="opacity-75">
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-6 text-center m-b-30 ml-auto">
            <div class="text-md-right d-flex justify-end flex-wrap">
              <!-- Main buttons displayed directly -->
              <v-btn
                v-can="'view roles'"
                :to="{name: 'role-dashboard'}"
                color="default"
                class="mx-1 mb-1"
              >
                <v-icon left>mdi-view-dashboard</v-icon>
                {{ $t('role.button.dashboard') }}
              </v-btn>

              <v-btn
                v-can="'view roles'"
                :to="{name: 'roles'}"
                color="success"
                class="mx-1 mb-1"
              >
                <v-icon left>mdi-format-list-bulleted</v-icon>
                {{ $t('role.button.all') }}
              </v-btn>

              <v-btn
                v-can="'create roles'"
                :to="{name: 'create-role'}"
                color="primary"
                class="mx-1 mb-1"
              >
                <v-icon left>mdi-plus</v-icon>
                {{ $t('role.button.create') }}
              </v-btn>

              <!-- More options dropdown menu -->
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="info"
                    class="mx-1 mb-1"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon left>mdi-dots-horizontal</v-icon>
                    {{ $t('common.more_options') }}
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-can="'view permissions'"
                    :to="{name: 'permissions'}"
                  >
                    <v-list-item-icon>
                      <v-icon color="warning">mdi-security-network</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>{{ $t('role.button.permissions') }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item
                    v-can="'view permissions'"
                    :to="{name: 'permission-manager'}"
                  >
                    <v-list-item-icon>
                      <v-icon color="error">mdi-cog</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>{{ $t('role.button.permission_manager') }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item
                    v-can="'view users'"
                    :to="{name: 'users'}"
                  >
                    <v-list-item-icon>
                      <v-icon color="info">mdi-account-group</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>{{ $t('user.button.all') }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item
                    v-can="'assign roles'"
                    :to="{name: 'user-role-manager'}"
                  >
                    <v-list-item-icon>
                      <v-icon color="success">mdi-account-multiple-plus</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>{{ $t('role.button.user_role_manager') }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition name="slide-fade">
      <router-view @parent-title="updateTitle"/>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Roles',
  data () {
    return {
      pageTitle: ''
    }
  },
  methods: {
    updateTitle (title) {
      this.pageTitle = title
    }
  }
}
</script>

<style scoped>

</style>
